import { MutableRefObject } from 'react';
import { SWIPE_RATIO, WHEEL_RATIO, WHEEL_INTERVAL_MAX, WHEEL_INTERVAL_LOW } from './zoom.provider';

export const swipeAccelerator = (deltaY: number, absY: number) => {
  const step = (deltaY / SWIPE_RATIO) * (absY / SWIPE_RATIO);
  return step;
};

export const wheelAccelerator = (deltaY: number, interval: Milliseconds, wheelClickCount: MutableRefObject<number>) => {
  if (interval > WHEEL_INTERVAL_MAX) wheelClickCount.current = 1;
  else if (interval > WHEEL_INTERVAL_LOW) wheelClickCount.current = Math.ceil(wheelClickCount.current / 2);
  else wheelClickCount.current++;
  const step = ((wheelClickCount.current * wheelClickCount.current) / 1000) * WHEEL_RATIO;
  if (deltaY < 0) return step * -1;
  return step;
};
